// Ana görev TOPLU işlem yürütücüsü — seçili görev id'lerine mevcut tasksApi
// çağrılarını uygular. Her işlem backend'e tek tek gider (Promise.allSettled →
// biri kilitli/başarısız olsa da diğerleri uygulanır).
import { tasksApi, taskLockApi } from "./api";

// action: done | paused | pending | overdue | archive | delete | pin | unpin | move
export async function runBulkTaskAction(ids, action, opts = {}) {
  const numberFor = opts.numberFor || (() => null);
  const calls = ids.map((id) => {
    switch (action) {
      case "done":
      case "paused":
      case "pending":
      case "overdue":
        return tasksApi.setStatus(id, action);
      case "move":
        return tasksApi.update(id, { category_id: opts.categoryId || "" });
      case "archive":
        return tasksApi.setArchived(id, true);
      case "delete":
        return tasksApi.delete(id);
      case "unpin":
        return tasksApi.update(id, { number_pinned: false, pinned_number: null });
      case "pin": {
        const n = numberFor(id);
        return n == null
          ? Promise.resolve()
          : tasksApi.update(id, { number_pinned: true, pinned_number: n });
      }
      // AŞAMA 3A — tek değerli toplu işlemler (mevcut tek görev uçları).
      case "cancel":
        return tasksApi.cancel(id);
      case "digest-mute":
        return tasksApi.update(id, { digest_muted: true });
      case "reassign":
        return tasksApi.reassign(id, opts.userId);
      case "reminder":
        return tasksApi.setReminder(id, opts.reminderAt, {
          intervalMin: opts.intervalMin ?? null,
          repeatLeft: opts.repeatLeft ?? null,
          repeatTotal: opts.repeatTotal ?? null,
        });
      case "due-soon":
        return tasksApi.update(id, opts.patch || {});
      case "reset-size":
        // Kart boyutu yereldir (localStorage) — API çağrısı yok.
        try {
          localStorage.removeItem(`sertex_task_size_${id}`);
          localStorage.removeItem(`sertex_task_dsize_${id}`);
        } catch (e) { console.warn("[taskBulkActions] hata bastırıldı:", e); }
        return Promise.resolve();
      // AŞAMA 3B — seçenek penceresi gerektiren işlemler.
      case "duplicate":
        return tasksApi.duplicate(id, opts.copyOpts || {});
      case "shares": {
        // BİRLEŞTİRME: mevcut paylaşımlar korunur, yenileri eklenir/güncellenir.
        const mevcut = opts.sharesFor?.(id) || [];
        const harita = new Map(mevcut.map((s) => [s.user_id, { user_id: s.user_id, perms: { ...(s.perms || {}) } }]));
        (opts.shares || []).forEach((s) => {
          const eski = harita.get(s.user_id);
          harita.set(s.user_id, { user_id: s.user_id, perms: { ...(eski?.perms || {}), ...(s.perms || {}) } });
        });
        return tasksApi.setShares(id, [...harita.values()], opts.notify !== false);
      }
      case "locks":
        return taskLockApi.setLocks(id, opts.flags || {}, opts.requiresOtp);
      default:
        return Promise.resolve();
    }
  });
  return Promise.allSettled(calls);
}

// Görev sıra numaralarını hesapla (sabitlenenler atlanır) — TasksPanel'deki
// numById ile aynı mantık; sıra numarası olmayan arayüzler (Profesyonel) için.
export function computeTaskNumbers(orderedTasks) {
  const m = {};
  const reserved = new Set();
  for (const t of orderedTasks) {
    if (t.status !== "done" && t.number_pinned && t.pinned_number != null) reserved.add(t.pinned_number);
  }
  let c = 0;
  for (const t of orderedTasks) {
    if (t.status === "done") { m[t.id] = null; continue; }
    if (t.number_pinned && t.pinned_number != null) { m[t.id] = t.pinned_number; continue; }
    c += 1;
    while (reserved.has(c)) c += 1;
    m[t.id] = c;
  }
  return m;
}
